<div class="highlightcard-list">
  <div
    class="highlightcard-list__item"
    [ngClass]="{ 'highlightcard-list__item--full': columns === '1' }"
    *ngFor="let item of items"
  >
    <hdi-highlightcard
      [datatype]="type"
      [HighlightcardItems]="[item]"
    ></hdi-highlightcard>
  </div>
</div>
